import { render } from "./my-documents.vue?vue&type=template&id=6a70d5c0&scoped=true"
import script from "./my-documents.vue?vue&type=script&lang=js"
export * from "./my-documents.vue?vue&type=script&lang=js"

import "./my-documents.vue?vue&type=style&index=0&id=6a70d5c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a70d5c0"]])

export default __exports__